
import CryptoJS from "crypto-js";
import apiClient from "./apiClient";


// Axios request wrapper with decryption
export const axiosRequest = async (method, url, token, request, headers) => {
    let config = {
        method,
        url,
        data: request,
        headers: {
            "token": token,
            ...headers,
        },
    };
    
    const test = url.includes("/upload")
    
    if (process.env.REACT_APP_ENCRYPTION_ALLOW == 'true' && (typeof request == "object") && test == false) {
        config = { ...config, data: encrypt(request), headers: { ...headers, 'Content-Type': "text/plain" } };
    }

    try {

        let data = await apiClient(config);
       
        if (data && data?.data && data?.data?.data) {
            if (process.env.REACT_APP_ENCRYPTION_ALLOW == 'true' && test == false) {
                const decryptedResponse = decrypt(data.data.data);
                data.data = { ...data.data, data: decryptedResponse }
            }
            return data.data;
        } else {
            return data?.data;
        }
    } catch (error) {
        // console.error("Error in axiosRequest:", error);
        // throw error;
        console.log("Error in axiosRequest:", error)
        return error
    }
};

export const axiosRequestForImage = async (method, url, token, request, headers) => {
    let config = {
        method,
        url,
        data: request,
        headers: {
            "token": token,
            ...headers,
        },
    };
    

    try {

        let data = await apiClient(config);
        if (data && data?.data && data?.data?.data) {
            if (process.env.REACT_APP_ENCRYPTION_ALLOW == 'true') {
                const decryptedResponse = decrypt(data.data.data);
                data.data = { ...data.data, data: decryptedResponse }
            }
            return data.data;
        } else {
            return data?.data;
        }
        
    } catch (error) {
        console.log("Error in axiosRequest: image", error)
        return
    }
};

const decrypt = (ciphertext) => {
    var bytes = CryptoJS.AES.decrypt(ciphertext, process.env.REACT_APP_ENCRYPTION_KEY);
    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
}
const encrypt = (data) => {
    try {
        if (!process.env.REACT_APP_ENCRYPTION_KEY) {
            throw new Error("Encryption key is missing. Check your environment variables.");
        }

        // console.log("Payload to encrypt:", data);

        // Convert the payload object to a string
        const stringifiedData = JSON.stringify(data);

        // Encrypt the stringified payload
        const ciphertext = CryptoJS.AES.encrypt(stringifiedData, process.env.REACT_APP_ENCRYPTION_KEY).toString();

        // console.log("Encrypted Payload:", ciphertext);
        return ciphertext;
    } catch (error) {
        console.error("Encryption failed:", error.message);
        throw error;
    }
};
